// material-ui
import { BusinessOutlined } from '@mui/icons-material';
import { Avatar, Backdrop, CircularProgress, FormControlLabel, Grid, Radio, RadioGroup, Stack, Typography } from '@mui/material';
import { openSnackbar } from 'api/snackbar';

// project import

import MainCard from 'components/MainCard';
import { APP_DEFAULT_PATH } from 'config';
import useAuth from 'hooks/useAuth';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import { useSWRConfig } from 'swr';
import { getErrorMessage } from 'utils/getErrorMessage';

// assets

const Companies = ({ handleToggle }) => {
  const navigate = useNavigate();
  const { cache } = useSWRConfig();

 const clearSwrCache = (excludedKeys) => {
    for (const key of cache.keys()) {
      if (!excludedKeys.some(excludedKey => key.includes(excludedKey))) {
        cache.delete(key);
      }
    }
  };
  const { user, changeCompany } = useAuth();
  const [selectedCompany] = useState(user.selectedCompany);
  const [open, setOpen] = useState(false);

  const handleCompanyChange = async (event) => {
    try {
      setOpen(true);
      const payload = {
        Email: user.email,
        CompanyName: event.target.value
      };
      await changeCompany(payload);
      clearSwrCache(['snackbar', 'api/menumaster']);
      navigate(APP_DEFAULT_PATH);
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      openSnackbar({
        open: true,
        message: errorMessage,
        variant: 'alert',
        alert: {
          color: 'error'
        }
      });
    } finally {
      setOpen(false);
      handleToggle();
    }
  };

  return (
    <>
      <RadioGroup row aria-label="payment-card" name="payment-card" value={selectedCompany} onChange={handleCompanyChange}>
        <Grid container spacing={2} sx={{ ml: 0 }}>
          {user.associatedCompanies.map((organization, index) => (
            <Grid item xs={12} key={index}>
              <FormControlLabel
                control={<Radio value={organization} sx={{ display: 'none' }} />}
                sx={{ display: 'flex', '& .MuiFormControlLabel-label': { flex: 1 } }}
                label={
                  <MainCard
                    content={false}
                    border={false}
                    boxShadow
                    sx={{
                      bgcolor: selectedCompany === organization ? 'primary.lighter' : 'white',
                      borderRadius: 3,
                      border: '1px solid black'
                    }}
                  >
                    <Stack spacing={1.5} alignItems="center" sx={{ py: 2 }}>
                      <Avatar sx={{ width: 46, height: 46, bgcolor: 'primary.lighter' }}>
                        <BusinessOutlined color="primary" />
                      </Avatar>
                      <Typography variant="caption" color={selectedCompany === organization ? 'primary' : 'black'}>
                        {organization}
                      </Typography>
                    </Stack>
                  </MainCard>
                }
              />
            </Grid>
          ))}
        </Grid>
      </RadioGroup>

      {open && (
        <Backdrop sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })} open={open}>
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
    </>
  );
};

export default Companies;
